/*
 * @Date: 2020-08-21 11:44:37
 * @LastEditTime: 2021-06-10 13:24:07
 */

/**
 * 配置编译环境和线上环境之间的切换
 * 默认三套环境，可以增添
 * 参考https://cli.vuejs.org/zh/guide/mode-and-env.html
 *
 */

let apiDomain,
  imgDomain,
  assetsUrl,
  mainUrl,
  appHome,
  thirdShareUrl,
  proposalUrl,
  factoryUrl,
  basiclawUrl,
  baosiKey,
  baosiBasicsUrl,
  coreUrlAddress,
  uploadFile,
  appId,
  train,
  importFile,
  TLPayHttp
// 可以多个接口域名，按需添加
switch (process.env.VUE_APP_FLAG) {
  case 'dev':
    apiDomain = 'http://39.104.118.120:8099/app/api/v1'
    imgDomain = 'http://39.104.118.120:8099/app/updown'
    // 静态服务资源
    assetsUrl = 'http://39.104.118.120:8099/app/static/'
    mainUrl = 'http://39.104.118.120:8099/app/h5'
    appHome = 'http://39.104.118.120:8099'
    factoryUrl = 'http://39.104.120.239:7025'
    baosiKey = '2dff76bb70653cb9e1a5bbceac524ce0'
    baosiBasicsUrl = 'http://121.28.4.58:16333/api/services/app/SalesMarket/UserLogin'
    train = 'http://39.104.67.108:8099/app/api/v1'
    break
  case 'uat':
    apiDomain = 'http://120.79.134.10:8099/app/api/v1'
    imgDomain = 'http://120.79.134.10:8099/app/updown'
    // 静态服务资源
    assetsUrl = 'http://120.79.134.10:8099/app/static/'
    mainUrl = 'http://120.79.134.10:8099/app/h5'
    appHome = 'http://120.79.134.10:8099'
    factoryUrl = 'http://120.79.134.10:7025'
    basiclawUrl = 'http://120.79.134.10:8099/api'
    baosiKey = '2dff76bb70653cb9e1a5bbceac524ce0'
    baosiBasicsUrl = 'http://121.28.4.58:16333/api/services/app/SalesMarket/UserLogin'
    coreUrlAddress = 'http://39.104.107.232:50002'
    uploadFile = 'http://39.104.116.211:7004'
    appId = 'wxba76efa541929a74'
    train = 'http://120.79.134.10:8099/app/api/v1'
    importFile = 'http://120.79.134.10:8099/app/static/images/app/file/'
    TLPayHttp = 'http://39.104.116.211:7088/pay'
    //公众号测试-----------------------------
    // apiDomain = 'http://myb.meilianyougou.com/h5test/app/api/v1'
    // imgDomain = 'http://39.104.67.108:8099/app/updown'
    // // // 静态服务资源
    // assetsUrl = 'https://myb.meilianyougou.com/h5test/app/static/'
    // mainUrl = 'https://myb.meilianyougou.com/h5test/app/h5'
    // appHome = 'http://39.104.67.108:8099'
    // factoryUrl = 'http://39.104.67.108:7025'
    // basiclawUrl = 'http://39.104.67.108:8099/api'
    // baosiKey = '2dff76bb70653cb9e1a5bbceac524ce0'
    // baosiBasicsUrl = 'http://121.28.4.58:16333/api/services/app/SalesMarket/UserLogin'
    // coreUrlAddress = 'http://39.104.107.232:50002'
    // uploadFile = 'http://39.104.116.211:7004'
    // appId = 'wxba76efa541929a74'
    // train = 'https://myb.meilianyougou.com/h5test/app/api/v1'
    // importFile = 'https://myb.meilianyougou.com/h5test/app/static/images/app/file/'
    // TLPayHttp = 'http://39.104.116.211:7088/pay'
    break
  case 'prd':
    apiDomain = 'http://myb.meilianyougou.com/app/api/v1'
    imgDomain = 'http://myb.meilianyougou.com/app/updown'
    // 静态服务资源
    assetsUrl = 'http://myb.meilianyougou.com/app/static/'
    mainUrl = 'http://myb.meilianyougou.com/app/h5'
    appHome = 'http://myb.meilianyougou.com'
    factoryUrl = 'https://myb.meilianyougou.com'
    basiclawUrl = 'https://myb.meilianyougou.com/api'
    baosiKey = '3D60168B90227FF8BEF2C78A3270CB79'
    uploadFile = 'http://myb.meilianyougou.com'
    appId = 'wxba76efa541929a74'
    baosiBasicsUrl = 'https://pay.xiaohecn.com/api/services/app/SalesMarket/UserLogin'
    coreUrlAddress = 'https://myb.meilianyougou.com/api/performance'
    train = 'http://myb.meilianyougou.com/app/api/v1'
    importFile = 'https://myb.meilianyougou.com/app/static/file/'
    TLPayHttp = 'https://myb.meilianyougou.com/app/api/v1/pay'
    break
}
/**
 * 配置文件
 * apiDomain: // 接口域名
 * upLoadDomain: // 存储上传文件域名
 * imgDomain: // 存储图片域名
 */
export default {
  apiDomain, // 主域名
  imgDomain, // 存储图片域名
  // 静态服务资源
  assetsUrl,
  mainUrl,
  appHome, // 域名地址
  thirdShareUrl, // 第三方分享链接
  proposalUrl,
  factoryUrl, //产品工厂
  basiclawUrl,
  baosiKey,
  baosiBasicsUrl,
  coreUrlAddress,
  uploadFile,
  appId,
  train,
  importFile,
  TLPayHttp,
}
